module.exports = __webpack_public_path__ + "img/game-tab.1e7d981b.png";